import { window } from '../../../../globals';
import useToastedMutation from '../../../../ReactQuery/useToastedMutation';
import { post } from '../../../../redux/api';
import { hardRedirectTo } from '../../../../utils';
import type { ConnectStartRequest, ConnectStartResponse } from '../../../../../shared/types/routes/vcs/githubApp';
import type { VcsApp } from '../../../../../shared/vcs/githubApp/apps';

const startGitHubAppInstall = async (app: VcsApp) => {
  /*
   * Send the current path so the install-callback returns the user here. The import page keeps
   * `connect` in the URL while its connect modal is open, and "Install on another account" starts
   * from that modal, so drop the flag or the user would land back on the modal.
   * Deleting re-encodes the whole query string, so only do it when the flag is there: every other
   * caller's path goes out exactly as the browser has it.
   */
  const url = new URL(window.location.href);
  if (url.searchParams.has('connect')) {
    url.searchParams.delete('connect');
  }
  const returnPath = `${url.pathname}${url.search}`;
  const response = await post<ConnectStartRequest, ConnectStartResponse>(
    `/api/vcs/github-apps/${app}/connect/start`,
    { returnPath, installOnly: true },
  );
  return response.data as ConnectStartResponse;
};

/**
 * Sends the user to GitHub to authorize, then straight on to GitHub's install page. vcs-service
 * verifies the installation against that authorization, so every install starts with it. The
 * install completes when vcs-service redirects back to `/api/vcs/github-apps/install-callback`.
 */
export function useStartGitHubAppInstall() {
  return useToastedMutation({
    mutationFn: startGitHubAppInstall,
    onSuccess: ({ authUrl }) => {
      hardRedirectTo(authUrl);
    },
    errorToastMessage: 'Failed to start GitHub App installation',
  });
}
